module.exports = "<div class=component-contract-control> <a class=contract-view>查看</a> <a class=contract-edit>编辑</a> <div class=contract-editor-anchor></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/contract-control/contract-control.html
// module id = 4724
// module chunks = 50